import { Field, FieldProps } from 'formik';
import React, { ReactNode } from 'react';

type Props = {
  name: string;
  children: (error: string) => ReactNode;
};

export default function FieldError({ name, children }: Props) {
  return (
    <Field>
      {(props: FieldProps) => {
        const error = props.form.errors[name];

        if (typeof error === 'string') {
          return children(error);
        }

        return null;
      }}
    </Field>
  );
}
